// Admin only: each agent's Team Lead Certification status and weekday activity (guardrail preview). Read-only.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { ArrowLeft } from 'lucide-react';
import { database } from '../firebaseConfig';
import { isCertExcluded } from '../shared/teamLeadCertAccess';
import { eligibility, TEAM_LEAD_GUARDRAIL_ENABLED } from '../shared/teamLeadGuardrail';
import { LESSON_IDS as lessonIds } from '../data/teamLeadCertQuiz';

const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const th = { textAlign: 'left', padding: '8px 10px', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8C6D1F', borderBottom: '2px solid #D4AF37' };
const td = { padding: '8px 10px', borderBottom: '1px solid #eee', fontSize: 14 };
const nameOf = (u) => [u.profile?.firstName || u.firstName, u.profile?.lastName || u.lastName].filter(Boolean).join(' ') || u.email || '(no name)';

export default function TeamLeadCertAdmin() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    get(ref(database, 'users')).then((s) => {
      const users = s.val() || {};
      setRows(Object.entries(users).filter(([, u]) => u && !isCertExcluded(u) && !u.disabled).map(([uid, u]) => {
        const c = u.teamLeadCertification || {};
        const acks = u.training?.teamLeadCert || {};
        const e = eligibility({ loginDays: u.activity?.loginDays, leadWorkDays: u.activity?.leadWorkDays });
        return { uid, name: nameOf(u), role: u.role || 'Agent', certified: !!u.teamLeadCertified, c, lessons: lessonIds.filter((id) => acks[id]).length, lastWeekMissed: e.lastWeek.missed };
      }).sort((a, b) => a.name.localeCompare(b.name)));
    }).catch(() => setRows([]));
  }, []);
  return (
    <div style={{ minHeight: '100vh', background: '#f7f4ee', fontFamily: FONT, padding: '20px 16px 40px', color: '#1a1a1a' }}>
      <button onClick={() => navigate('/admin')} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'transparent', border: '1px solid #d8c9a8', borderRadius: 6, padding: '8px 12px', cursor: 'pointer', fontFamily: FONT }}><ArrowLeft size={16} /> Back to admin</button>
      <h1 style={{ fontSize: 22, margin: '16px 0 4px' }}>Team Lead Certification</h1>
      <p style={{ color: '#6b6b6b', margin: '0 0 16px' }}>Daily activity rule: {TEAM_LEAD_GUARDRAIL_ENABLED ? 'ON' : 'OFF (preview only, nothing is paused)'}. Amanda is excluded.</p>
      <div style={{ background: '#fff', border: '1px solid #e5e5e5', borderRadius: 8, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Agent</th><th style={th}>Lessons</th><th style={th}>Certified</th><th style={th}>Best score</th><th style={th}>Date</th><th style={th}>Attempts</th><th style={th}>Weekdays missed last week</th></tr></thead>
          <tbody>
            {rows === null && <tr><td style={td} colSpan={7}>Loading…</td></tr>}
            {(rows || []).map((r) => (
              <tr key={r.uid}>
                <td style={td}>{r.name}<span style={{ color: '#7f7f7f', fontSize: 12 }}> · {r.role}</span></td>
                <td style={td}>{r.lessons} of {lessonIds.length}</td>
                <td style={{ ...td, fontWeight: 700, color: r.certified ? '#2f6f2f' : '#9b2c2c' }}>{r.certified ? 'Yes' : 'No'}</td>
                <td style={td}>{r.c.score != null ? `${r.c.score}%` : '-'}</td>
                <td style={td}>{r.c.date ? new Date(r.c.date).toLocaleDateString() : '-'}</td>
                <td style={td}>{r.c.attempts || 0}</td>
                <td style={td}>{r.lastWeekMissed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
